import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { apiGetFarmerPackageDetails } from 'services/AuthService';

export const getFarmerPackageDetails = createAsyncThunk(
    "auth/session/getFarmerPackageDetails",
    async (farmerPackageID) => {
        const response = await apiGetFarmerPackageDetails(farmerPackageID);
        return (response?.data);
    }
);

export const sessionSlice = createSlice({
    name: 'auth/session',
    initialState: {
        token: '',
        signedIn: false,
        farmerPackagePdfDetails: null,
    },
    reducers: {
        onSignInSuccess: (state, action) => {
            state.signedIn = true
            state.token = action.payload
        },
        onSignOutSuccess: (state) => {
            state.signedIn = false
            state.token = ''
        },
        setToken: (state, action) => {
            state.token = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFarmerPackageDetails.pending, (state) => {
                state.farmerPackagePdfDetails = null;
            })
            .addCase(getFarmerPackageDetails.fulfilled, (state, action) => {
                state.farmerPackagePdfDetails = action.payload;
            })
            .addCase(getFarmerPackageDetails.rejected, (state) => {
                state.farmerPackagePdfDetails = null;
            });
    }
})

export const { onSignInSuccess, onSignOutSuccess, setToken, } = sessionSlice.actions

export default sessionSlice.reducer